import { render, staticRenderFns } from "./OpsCenter.vue?vue&type=template&id=bea0a4ac&scoped=true"
import script from "./OpsCenter.vue?vue&type=script&lang=js"
export * from "./OpsCenter.vue?vue&type=script&lang=js"
import style0 from "./OpsCenter.vue?vue&type=style&index=0&id=bea0a4ac&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bea0a4ac",
  null
  
)

export default component.exports